export const FETCH_REGION_REQUEST = 'FETCH_REGION_REQUEST';
export const FETCH_REGION_SUCCESS = 'FETCH_REGION_SUCCESS';
export const FETCH_REGION_FAILURE = 'FETCH_REGION_FAILURE';

export const fetchRegionRequest = id => ({
  type: FETCH_REGION_REQUEST,
  payload: { id }
});

export const fetchRegionSuccess = response => ({
  type: FETCH_REGION_SUCCESS,
  payload: response
});

export const fetchRegionFailure = err => ({
  type: FETCH_REGION_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/region/actions.js